<template>
  <div class="myQuest">
    <input
      id="inputFile"
      type="file"
      @change="uploadFile"
      style="display: none"
    />
    <div class="tabBox" v-show="!showInfo">
      <div
        class="item"
        @click="getQuestList(v, true)"
        :class="{ active: active == v.type }"
        v-for="(v, i) in tab"
        :key="i"
      >
        {{ v.name }}
      </div>
    </div>

    <div class="contentList" @scroll="scrollTask" v-show="!showInfo">
      <div class="item" v-for="(v, i) in tab[active].list" :key="i">
        <div class="top">
          <div class="createTime">时间: {{ v.createTime }}</div>

          <div class="statusText">
            {{ v.statusText }}
          </div>
        </div>

        <div class="contentItem">
          <div class="icon" :class="{ IsMe: v.publishReceiveType != 1 }">
            发
          </div>

          <div class="demand">
            <div class="taskName">
              {{ v.taskName }}
              <div class="tsakDetails" @click="goTaskDetails(v, 1)">
                任务详情
              </div>
            </div>
            <div class="taskRequire">
              {{ v.taskRequire }}
            </div>
            <div
              class="taskName"
              v-if="v.publishReceiveType != 1"
              style="margin-top: 10px"
            >
              {{ v.taskFromNickName }}
              <img
                class="userimg"
                :src="require('assets/images/writerPage_toux.png')"
                alt=""
              />
            </div>
            <div class="taskRequire" v-if="v.publishReceiveType != 1">
              {{ v.createTime }}
            </div>
          </div>
        </div>

        <div class="contentItem">
          <div class="icon">接</div>

          <div class="demand">
            <div class="taskName">
              {{ v.taskToNickName || '暂无接单' }}
              <span class="me" v-if="v.publishReceiveType != 1">(我)</span>
              <img
                v-else
                class="userimg"
                :src="require('assets/images/writerPage_toux.png')"
                alt=""
              />
            </div>
            <div class="taskRequire">
              {{ v.taskStartTime }}
            </div>
          </div>
        </div>
        <div class="but_time_box">
          <div class="time">
            <img :src="imgUrl + 'task_time_img.png'" />
            <span
              >{{ v.taskHour
              }}{{
                v.taskHourType == 0
                  ? '个小时'
                  : v.taskHourType == 1
                  ? '天'
                  : v.taskHourType == 2
                  ? '个月'
                  : v.taskHourType == 3
                  ? '年'
                  : ''
              }}内完成</span
            >
          </div>
          <div class="price_box">
            <span style="font-size: 15px; font-weight: bold">￥</span>
            {{ v.taskPrice }}
          </div>
        </div>
        <el-progress
          :text-inside="true"
          :stroke-width="26"
          :percentage="v.taskStartTime == null ? 0 : v.count"
        ></el-progress>
        <div class="bottom">
          <div class="option" v-if="v.publishReceiveType == 1">
            <div
              class="but moren"
              v-if="v.status === 2"
              @click.stop="testVerify(1, v.id)"
            >
              终止委托
            </div>
            <div
              class="but erjipri"
              v-if="v.status === 1"
              @click.stop="closeTask(v)"
            >
              关闭任务
            </div>
            <div
              class="but erjipri"
              v-if="v.status === 7 || v.status === 10"
              @click.stop="goTaskDetails(v, 3)"
            >
              验收任务
            </div>
            <div
              class="but primary"
              v-if="v.status === 1"
              @click.stop="goTaskDetails(v, 2)"
            >
              修改任务
            </div>
            <div
              class="but primary"
              v-if="v.status === 2"
              @click.stop="taskUrge(v)"
            >
              催催任务
            </div>
          </div>
          <div class="option" v-else>
            <div
              class="but moren"
              v-if="v.status === 2"
              @click.stop="clickBut(1, v.id)"
            >
              终止委托
            </div>
            <div
              class="but erjipri"
              v-if="v.status === 2"
              @click.stop="submitAcceptance(v, true)"
            >
              提交验收
            </div>
            <div
              class="but primary"
              v-if="v.status === 2"
              @click.stop="submitAcceptance(v, false)"
            >
              反馈进度
            </div>
            <div
              class=""
              v-if="
                v.status === 9 && v.taskFromUserId !== $store.state.user_info.id
              "
              style="
                color: #ff251a;
                font-size: 14px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <span>您有一笔新订单，请及时处理</span>
              <div class="but primary">去处理</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="details" v-show="showInfo">
      <homeDetails
        @back="showInfo = false"
        :dataInfo="dataInfo"
        :isExamine="isExamine"
      ></homeDetails>
    </div>
    <div class="showDialog" v-show="show_pop">
      <div class="close" @click="show_pop = false">
        <i class="el-icon-close"></i>
      </div>
      <div class="message_box" style="padding: 0">
        <div v-if="type === 1 && verification">
          <div class="title">
            <img :src="imgUrl + 'editedBooks_dialogTip.png'" />
            <span>验证完成确认</span>
          </div>
          <div class="subtitle">验收完成后，款项将支付给任务接单人。</div>
          <div class="rate_box">
            <span>评级</span>
            <u-rate
              v-model="verification.star"
              activeColor="#f6b529"
              size="38rpx"
            />
          </div>
          <div class="text_area_box">
            <textarea
              v-model="verification.content"
              style="width: 100%; height: 100%; border: none"
              placeholder="请输入评论"
              :maxlength="251"
            ></textarea>
          </div>
        </div>
        <div v-else-if="type === 2">
          <div class="title">
            <img :src="imgUrl + 'userPortfolio_dialogTip.png'" />
            <span>单方终止委托确认</span>
          </div>
          <div class="price_text_box">
            <span>需要支付补偿金</span>
            <span style="color: #ff4e4e"
              >{{ verification.gs.redressAmount || 0 }}元</span
            >
          </div>
          <div class="subtitle" style="font-size: 24rpx">
            <div class="" style="margin-bottom: 10rpx">
              委托金额*已过时间/时限=补偿金额
            </div>
            <div class="">{{ verification.gs.formulaResult }}</div>
          </div>
          <div class="liyou">
            <span style="color: red; margin-right: 10rpx">*</span> 终止委托原因
          </div>
          <div class="text_area_box">
            <textarea
              v-model="verification.terminationReason"
              style="width: 100%; height: 100%; border: none"
              placeholder="请输入终止委托原因"
              :maxlength="251"
            ></textarea>
          </div>
        </div>
        <div v-else-if="type === 3">
          <div class="title">
            <img :src="imgUrl + 'userPortfolio_dialogTip.png'" />
            <span>单方终止委托确认</span>
          </div>
          <div class="subtitle" style="font-size: 24rpx">
            <div class="">单方终止委托将全额退还委托人预付款项</div>
          </div>
          <div class="liyou">
            <span style="color: red; margin-right: 10rpx">*</span>终止委托原因
          </div>
          <div class="text_area_box">
            <textarea
              v-model="verification.terminationReason"
              style="width: 100%; height: 100%; border: none"
              placeholder="请输入终止委托原因"
              :maxlength="251"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="option">
        <div class="confirm" @click="clickConfirm">确认</div>
        <div class="cancel" @click="show_pop = false">取消</div>
      </div>
    </div>
    <div class="checkDialog" v-show="check_show">
      <div class="close" @click="check_show = false">
        <i class="el-icon-close"></i>
      </div>
      <div class="message_box">
        <div class="select_box_up">
          <div class="tit_sel">
            <div class="" style="">
              {{
                isCheck ? '上传验收相关资料(非必填)' : '上传相关资料(非必填)'
              }}
            </div>
            <div
              @click="uploadClick"
              class=""
              style="display: flex; align-items: center; cursor: pointer"
            >
              <i class="el-icon-plus" style="color: #326afb"></i>
              <span style="margin: 0 0 0 5px; color: #326afb">上传</span>
            </div>
          </div>
          <div class="item_sel" v-for="(el, i) in taskFiles" :key="i">
            <div
              class=""
              style="display: flex; align-items: center"
              @click="downFile(el)"
            >
              <span style="color: #333; margin-right: 5px">{{ i + 1 }}.</span>
              {{ el.fileName }}
            </div>
            <!-- <div
              class=""
              style="display: flex; align-items: center"
              v-else
              @click="viewImg(el.filePath)"
            >
              <span style="color: #333; margin-right: 5px">{{ i + 1 }}.</span>
              <img style="width: 50px" :src="el.filePath" mode="widthFix" />
            </div> -->
            <i
              class="el-icon-close"
              style="color: 666; cursor: pointer"
              @click="deUpword(i)"
            ></i>
          </div>
        </div>
        <div class="text_cont">
          <span style="color: red; margin-right: 5px">*</span>
          {{ isCheck ? '成果内容' : '反馈内容' }}
        </div>
        <div class="text_area_box">
          <textarea
            v-model="content"
            style="width: 100%; height: 100%; border: none; resize: none"
            :placeholder="isCheck ? '请简单描述成果内容...' : '请输入反馈...'"
            :maxlength="251"
          ></textarea>
        </div>
      </div>
      <div class="option">
        <div class="confirm" @click="checkConfirm">确认</div>
        <div class="cancel" @click="check_show = false">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  myQuest,
  taskEndRedressInfo,
  entrustTaskEnd,
  checkAccept,
  taskEndRedress,
  closeTask,
  taskUrge,
  ossUpload,
  submitAcceptance,
  feedbackProgress,
  taskInfo,
} from '@/api/professionServer'
import homeDetails from '../Home/components/homeDetails'
import qs from 'qs'
export default {
  name: 'myQuest',
  //import引入的组件需要注入到对象中才能使用
  components: {
    homeDetails,
  },
  data() {
    //这里存放数据
    return {
      active: 0,
      total: 0,
      type: 0, // 判断是那种弹窗
      imgUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/',
      tab: [
        {
          name: '全部',
          type: 0,
          page: 1,
          list: [],
        },
        {
          name: '进行中',
          type: 1,
          page: 1,
          list: [],
        },
        {
          name: '完成',
          type: 2,
          page: 1,
          list: [],
        },
        {
          name: '终止',
          type: 3,
          page: 1,
          list: [],
        },
      ],
      showInfo: false,
      page: 1,
      dataList: [],
      taskFiles: [],
      taskData: {},
      verification: null,
      currentItem: {},
      isCheck: false, //提交验收
      content: '',
      show_pop: false,
      check_show: false,
      tab_xz: 0,
      isExamine: false,
      dataInfo: {},
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    scrollTask(e) {
      let scrollTop = e.target.scrollTop //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = e.target.clientHeight //能看到的页面的高度
      let scrollHeight = e.target.scrollHeight //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht

      if (total == scrollHeight) {
        this.tab[this.active].page++
        this.getQuestList(this.tab[this.active])
      }
    },

    goTaskDetails(item, type) {
      taskInfo(item.id).then((res) => {
        if (res.code === 200) {
          this.dataInfo = res.data
          this.dataInfo.twqReminderAndTaskFeedBack.forEach((item) => {
            item.files = JSON.parse(item.files)
          })
          if (type == 3) {
            this.isExamine = true
            this.showInfo = true
          } else if (type == 2) {
            this.$emit('updateTask', this.dataInfo)
          } else {
            this.isExamine = false
            this.showInfo = true
          }
        }
      })
    },
    async getQuestList(val, reset = false) {
      this.active = val.type
      if (reset) {
        val.page = 1
        val.list = []
      }
      const data = {
        limit: 10,
        page: val.page,
        type: val.type,
      }

      const res = await myQuest(data)

      if (res.code == 200) {
        val.list = [...val.list, ...res.data.data]
        val.list.forEach((el, i) => {
          this.$set(el, 'count', 0)

          let nowTime = new Date()
          let taskTime = new Date(el.taskStartTime.replaceAll('-', '/'))
          let count =
            ((nowTime - taskTime) / (1000 * 60) / (el.totalTaskHour * 60)) * 100
          if (count >= 100) {
            count = 100
          }
          this.$set(el, 'count', Math.floor(count))
        })
        // this.total = 0;
      }
    },
    async testVerify(type, id) {
      let opt = {
        type: '',
        id,
      }
      if (type === 1) {
        opt.type = 'compensate'
        let res = await taskEndRedressInfo({
          taskId: id,
        })
        if (res.code !== 200) return
        opt.gs = res.data
      } else if (type === 3) {
        opt.type = 'verification'
      }
      this.pClickBut(opt)
    },
    clickBut(type, id) {
      let opt = {
        id,
      }
      if (type === 1) {
        opt.type = 'compensate'
        this.rClickBut(opt)
      }
    },
    // 发布任务的
    pClickBut(data) {
      let obj = {}
      if (data.type === 'verification') {
        this.type = 1
        obj.taskId = data.id
        obj.star = 0
      } else if (data.type === 'compensate') {
        this.type = 2
        obj.taskId = data.id
        obj.gs = data.gs
      }
      this.verification = obj
      this.taskData = data
      this.show_pop = true
    },
    // 接任务的
    rClickBut(data) {
      let obj = {}
      if (data.type === 'compensate') {
        this.type = 3
        obj.taskId = data.id
      }
      this.verification = obj
      this.taskData = data
      this.show_pop = true
    },
    clickConfirm() {
      let data = this.taskData
      console.log(this.type)
      if (this.type === 3) {
        if (data.type === 'compensate') {
          this.entrustTaskEnd()
        }
        return
      }
      if (data.type === 'verification') {
        this.checkAccept()
      } else {
        this.taskEndRedress()
      }
    },
    // 单方终止委托接口（接单人）
    async entrustTaskEnd() {
      if (!this.verification.terminationReason) {
        this.$message.error('填写终止委托原因')
        return
      }

      let opt = {
        ...this.verification,
      }
      delete opt.gs
      let res = await entrustTaskEnd(opt)
      if (res.code !== 200) return
      this.show_pop = false
      this.$message.success('终止任务成功')
      setTimeout(() => {
        this.getQuestList(this.tab[this.active], true)
      }, 1000)
    },
    // 验收(任务发起人)
    async checkAccept() {
      let opt = {
        ...this.verification,
      }
      if (!opt.content) {
        this.$message.error('请输入评论')
        return
      }
      let res = await checkAccept(JSON.stringify(opt))
      if (res.code !== 200) return
      this.show_pop = false
      this.$message.success('验证成功')
      setTimeout(() => {
        this.getQuestList(this.tab[this.active], true)
      }, 1000)
    },
    // 终止任务
    async taskEndRedress() {
      if (!this.verification.terminationReason) {
        this.$message.error('填写终止委托原因')
        return
      }
      let opt = {
        ...this.verification,
      }
      delete opt.gs
      let res = await taskEndRedress(JSON.stringify(opt))
      if (res.code !== 200) return
      this.show_pop = false
      this.$message.success('终止任务成功')
      setTimeout(() => {
        this.getQuestList(this.tab[this.active], true)
      }, 1000)
    },
    closeTask(item) {
      this.$confirm('确认是否关闭任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async (res) => {
          let data = await closeTask(
            qs.stringify({
              taskId: item.id,
            })
          )
          if (data.code !== 200) return
          // this.queryWqtaskUser();
          this.getQuestList(this.tab[this.active], true)
        })
        .catch(() => {})
    },
    taskUrge(item) {
      this.$confirm('是否催催任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async (res) => {
          let data = await taskUrge(
            qs.stringify({
              taskId: item.id,
            })
          )
          if (data.code === 418) {
            this.$message.info(data.data)
            return
          }
          if (data.code !== 200) return
          this.$message.success('催任务成功')
          // this.queryWqtaskUser();
        })
        .catch(() => {})
    },
    uploadFile(e) {
      console.log(e.target.files[0])
      const file = e.target.files[0]
      const form = new FormData()
      form.append('file', file)
      ossUpload(form).then((res) => {
        this.taskFiles.push({
          fileName: file.name,
          filePath: res.data,
        })
        // if (file.type.indexOf("image") == -1) {
        //   this.taskFiles.push({
        //     fileName: file.name,
        //     filePath: res.data,
        //   });
        // } else {
        //   this.taskFiles.push({
        //     fileName: 'image'+ (this.taskFiles.length),
        //     filePath: res.data,
        //   });
        // }
      })
    },
    uploadClick() {
      const input = document.querySelector('#inputFile')
      input.click()
    },
    downFile(item) {
      window.open(item.filePath + '?attname=' + item.fileName)
    },
    deUpword(i) {
      this.taskFiles.splice(i, 1)
    },
    submitAcceptance(item, check) {
      this.currentItem = item
      this.isCheck = check
      this.check_show = true
    },
    async checkConfirm() {
      if (this.isCheck) {
        if (!this.content) {
          this.$message.error('请填写成果内容')
          return
        }
        let opt = {
          content: this.content,
          files: JSON.stringify(this.taskFiles),
          taskId: this.currentItem.id,
          type: 1,
        }
        let res = await submitAcceptance(opt)
        this.check_show = false
        if (res.code !== 200) return
        this.$message.success('提交验收成功')
        this.getQuestList(this.tab[this.active], true)
        this.content = ''
        this.taskFiles = []
      } else {
        if (!this.content) {
          this.$message.error('请填写反馈内容')
          return
        }
        let opt = {
          content: this.content,
          files: JSON.stringify(this.taskFiles),
          taskId: this.currentItem.id,
          type: 0,
        }
        let res = await feedbackProgress(opt)
        this.check_show = false
        if (res.code !== 200) return
        this.$message.success('反馈成功')
        this.content = ''
        this.taskFiles = []
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getQuestList(this.tab[this.active])
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {
    clearInterval(this.timer)
    this.timer = []
  }, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.myQuest {
  width: 1130px;
  margin: 20px auto;
  background-color: #fff;
  padding: 15px 0px;
  box-sizing: border-box;
  border-radius: 10px;
  .tabBox {
    display: flex;
    align-items: center;
    font-size: 15px;
    gap: 20px;
    padding: 0 20px;
    .item {
      cursor: pointer;
      padding: 10px;
      border-radius: 5px;
    }

    .active {
      background: #edf2ff;
      color: #326afb;
    }
  }
  .details {
    height: 600px;
    padding: 10px 20px;
    overflow: auto;
  }
  .contentList {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    height: 600px;
    padding: 10px 20px;
    overflow: auto;
    .item {
      padding: 15px;
      box-sizing: border-box;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .createTime {
          font-size: 16px;
          font-weight: bold;
        }
        .statusText {
          font-size: 15px;
          color: #999;
        }
      }
      .contentItem {
        display: flex;
        align-items: flex-start;
        gap: 15px;

        .icon {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          // align-items: center;
          text-align: center;
          line-height: 25px;
          font-size: 14px;
          color: #326afb;
          background: #f2f6ff;
        }
        .IsMe {
          color: #fff;
          background: #f9bc3e;
        }
        .demand {
          flex: 1;
          .taskName {
            height: 25px;
            line-height: 25px;
            display: flex;
            // justify-content: space-between;
            // align-items: center;
            .tsakDetails {
              color: #326afb;
              cursor: pointer;
            }
            gap: 6px;
            .userimg {
              margin-top: 2px;
              width: 18px;
              height: 18px;
              cursor: pointer;
            }
          }
          .taskRequire {
            margin-top: 5px;
            line-height: 20px;
            font-size: 15px;
            color: #999;
          }
        }
      }
      .but_time_box {
        width: 100%;
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .time {
          display: flex;
          align-items: center;

          > img {
            width: 18px;
            height: 18px;
            margin-right: 15px;
          }
        }

        .price_box {
          font-size: 44rpx;
          color: #ff5346;
        }
      }
      .bottom {
        .option {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 10px;
          .blue {
            color: #326afb;
          }

          .grey {
            color: #999999;
          }

          .but {
            padding: 8px 18px;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 25px;
            cursor: pointer;
          }

          .moren {
            background: #ffffff;
            border: 1px solid #d9d9d9;
            color: #333333;
            margin-left: 10px;
          }

          .primary {
            background-color: #326afb;
            color: #fff;
            margin-left: 10px;
          }

          .erjipri {
            color: #326afb;
            background: #f0f4ff;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .checkDialog {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
    width: 500px;
    padding: 15px;
    padding-bottom: 0;
    border-radius: 10px;
    .close {
      cursor: pointer;
      text-align: right;
    }
    .option {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .confirm {
        font-size: 14px;
        color: #fff;
        background: #326afb;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 70px;
        border-radius: 5px;
      }
      .cancel {
        font-size: 14px;
        color: #fff;
        background: #999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 70px;
        border-radius: 5px;
      }
    }
    .message_box {
      width: 100%;
      // padding: 50rpx 50rpx 0;
      box-sizing: border-box;
      .text_cont {
        margin-bottom: 5px;
      }
      .select_box_up {
        width: 100%;
        min-height: 50px;
        background: #f7f8fa;
        border-radius: 10px;
        padding: 0 15px;
        box-sizing: border-box;
        margin-bottom: 10px;
        border-bottom: 1px solid transparent;

        > div {
          width: 100%;
          min-height: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .tit_sel {
          margin-bottom: 5px;
          font-size: 15px;

          > view:first-child {
            font-weight: 600;
            color: #666666;
          }
        }

        .item_sel {
          min-height: 30px;
          margin-bottom: 5px;

          > div:first-child {
            font-size: 15px;
            color: #326afb;
            cursor: pointer;
          }

          > div:last-child {
            font-size: 15px;
            color: #333333;
            display: flex;
            align-items: center;
            font-weight: 600;

            > img {
              width: 15px;
              height: 15px;
            }
          }
        }
      }
      .text_area_box {
        width: 100%;
        height: 105px;
        padding: 15px;
        box-sizing: border-box;
        font-size: 15px;
        background: #f6f8fc;
        border-radius: 10px;
      }
    }
  }
  .showDialog {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
    width: 500px;
    padding: 15px;
    padding-bottom: 0;
    border-radius: 10px;
    .close {
      position: absolute;
      top: 15px;
      right: 15px;
      z-index: 999;
      cursor: pointer;
    }
    .option {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .confirm {
        font-size: 14px;
        color: #fff;
        background: #326afb;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 70px;
        border-radius: 5px;
      }
      .cancel {
        font-size: 14px;
        color: #fff;
        background: #999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 70px;
        border-radius: 5px;
      }
    }
    .message_box {
      width: 100%;
      // padding: 50rpx 50rpx 0;
      box-sizing: border-box;

      .title {
        display: flex;
        align-items: center;
        font-size: 17px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 18px;

        > img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
      }

      .price_text_box {
        width: 100%;
        font-size: 14px;
        color: #333333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 18px;
      }

      .subtitle {
        font-size: 14px;
        color: #999999;
        margin-bottom: 18px;
      }

      .rate_box {
        display: flex;
        align-items: center;
        margin-bottom: 18px;

        > span {
          font-size: 15px;
          font-weight: bold;
          color: #333333;
          margin-right: 15px;
        }
      }

      .liyou {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        margin-bottom: 15px;
      }

      .text_area_box {
        width: 100%;
        height: 105px;
        padding: 15px;
        box-sizing: border-box;
        font-size: 15px;
        background: #f6f8fc;
        border-radius: 10px;
        textarea {
          resize: none;
        }
      }
    }
  }
}
</style>
